const License = () =>
  import(
    /* webpackChunkName: "security-license-permission" */ '@/pages/security/license-permission/index.vue'
  )
const Detail = () =>
  import(
    /* webpackChunkName: "security-license-permission" */ '@/pages/security/license-permission/detail.vue'
  )
const CreateLicense = () =>
  import(
    /* webpackChunkName: "security-license-permission" */ '@/pages/security/license-permission/create.vue'
  )
const EditLicense = () =>
  import(
    /* webpackChunkName: "security-license-permission" */ '@/pages/security/license-permission/edit.vue'
  )

export default {
  path: 'license-permission',
  meta: {
    label: 'permissionLicense',
    auth: 'licensePermission'
  },
  component: {
    name: 'License',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SecurityLicenseReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: License
    },
    {
      name: 'SecurityLicenseDetail',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    },
    {
      name: 'SecurityCreateLicense',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateLicense
    },
    {
      name: 'SecurityEditLicense',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditLicense,
      props: true
    }
  ]
}
